import { WaterbodyDetail } from '@omniafishing/core';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isDone, isPending } from '../../constants/loading_state';
import { usePrevious } from '../../hooks/use_previous';
import { getActivationLoadingState } from '../../redux/waterbody';
import WaterbodyActivationRequestModal from '../waterbody_activation_request_modal/waterbody_activation_request_modal';

export const WaterbodyActivation: React.FC<{
  waterbody: WaterbodyDetail;
  urlSlug: string;
}> = (props) => {
  const { waterbody, urlSlug } = props;

  const activationLoadingState = useSelector(getActivationLoadingState);
  const prevActivationLoadingState = usePrevious(activationLoadingState);
  const [activationRequested, setActivationRequested] = useState(false);
  useEffect(() => {
    if (isPending(prevActivationLoadingState) && isDone(activationLoadingState)) {
      setActivationRequested(true);
    }
  }, [activationLoadingState]);

  const [activateModalOpen, setActivateModalOpen] = useState(false);

  const waterbodyActive = waterbody.species_known || waterbody.omnia_clarity != null;
  if (waterbodyActive) {
    return null;
  }

  if (activationRequested || waterbody.activation_requested) {
    return (
      <div style={{ padding: '24px', backgroundColor: '#FFE65C' }}>
        <h2
          style={{
            color: 'rgba(40, 66, 79, 0.85)',
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}
        >
          Your request to activate is pending
        </h2>
        <p>
          While we're processing your request, select species or styles below to browse
          recommendations.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', backgroundColor: '#cde2eb' }}>
      <h2
        style={{
          color: 'rgba(40, 66, 79, 0.85)',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}
      >
        Where's all the info?
      </h2>
      <p>
        Due to the number of waterbodies, we have to prioritize which waterbodies we integrate into
        our system. By clicking the 'Activate' button, you can let us know there is demand for more
        information and recommendations for this waterbody.
      </p>
      <Button
        onClick={() => {
          setActivateModalOpen(true);
        }}
        type="primary"
        size="large"
      >
        Request Activation
      </Button>
      <WaterbodyActivationRequestModal
        onCancel={() => {
          setActivateModalOpen(false);
        }}
        open={activateModalOpen}
        urlSlug={urlSlug}
      />
    </div>
  );
};
